import user from './User';
import group from './Group';

const Api: Record<string, any> = { user, group };
export default Api;
